import { PureComponent } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Segment, Grid, Accordion, Table } from 'semantic-ui-react';

import { isEmpty, get, map } from '../../utils/lodash';
import { CustomSegment, EmptyContainer } from '../../components';
import { getOrganisationAdmins } from '../../store/actions';

import './auth.scss';

class Help extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { user, getOrganisationAdmins } = this.props;
    if (get(user, 'organisationId')) {
      getOrganisationAdmins();
    }
  }

  panels = () => {
    const { t } = this.props;
    return [
      {
        key: 1,
        title: {
          content: <span>{t('auth.help.q1.title')}</span>,
        },
        content: {
          content: (
            <div>
              <p>
                <strong>{t('auth.help.answer')}</strong>
              </p>
              <p>
                <Trans
                  i18nKey="auth.help.q1.description"
                  components={{
                    1: (
                      <a
                        href={'https://culturaldevelopment.net.au/whitebox/'}
                        target="_blank"
                        rel="noopener noreferrer"
                      />
                    ),
                  }}
                />
              </p>
            </div>
          ),
        },
      },
      {
        key: 2,
        title: {
          content: <span>{t('auth.help.q2.title')}</span>,
        },
        content: {
          content: (
            <div>
              <p>
                <strong>{t('auth.help.answer')}</strong>
              </p>

              <p>{t('auth.help.q2.description')}</p>
              <ol>
                <li>{t('auth.help.q2.description_line1')}</li>
                <li>{t('auth.help.q2.description_line2')}</li>
                <li>{t('auth.help.q2.description_line3')}</li>
                <li>{t('auth.help.q2.description_line4')}</li>
              </ol>
            </div>
          ),
        },
      },
      {
        key: 3,
        title: {
          content: <span>{t('auth.help.q3.title')}</span>,
        },
        content: {
          content: (
            <div>
              <p>
                <strong>{t('auth.help.answer')}</strong>
              </p>
              <p>
                <Trans
                  i18nKey="auth.help.q3.description"
                  components={{ strong: <strong /> }}
                />
              </p>
            </div>
          ),
        },
      },
      {
        key: 4,
        title: {
          content: <span>{t('auth.help.q4.title')}</span>,
        },
        content: {
          content: (
            <div>
              <p>
                <strong>{t('auth.help.answer')}</strong>
              </p>
              <p>{t('auth.help.q4.description')}</p>
            </div>
          ),
        },
      },
      {
        key: 5,
        title: {
          content: <span>{t('auth.help.q5.title')}</span>,
        },
        content: {
          content: (
            <div>
              <p>
                <strong>{t('auth.help.answer')}</strong>
              </p>
              <p>{t('auth.help.q5.description')}</p>
            </div>
          ),
        },
      },
    ];
  };

  renderAdminList() {
    const { adminList, t } = this.props;
    const withoutCdnAdmins = adminList.filter((user) => {
      const userEmail = get(user, 'email', '');
      const isCdnAdmin = userEmail.includes('cdn-admin');
      return !isCdnAdmin;
    });

    return (
      <div>
        {isEmpty(withoutCdnAdmins) ? (
          <EmptyContainer msg={t('auth.help.no_takso_administrators_found')} />
        ) : (
          <Table className="info-table" stackable structured={false}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>{t('formulary.name')}</Table.HeaderCell>
                <Table.HeaderCell>{t('formulary.email')}</Table.HeaderCell>
                <Table.HeaderCell>{t('formulary.phone')}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {map(withoutCdnAdmins, (item, i) => {
                return (
                  <Table.Row key={i}>
                    <Table.Cell>
                      {get(item, 'name', '-')}
                      {item.positionTitle ? `, ${item.positionTitle}` : null}
                    </Table.Cell>
                    <Table.Cell>
                      <a href={`mailto:${item.email}`}>{item.email}</a>
                    </Table.Cell>
                    <Table.Cell>{item.phone ? item.phone : '-'}</Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        )}
      </div>
    );
  }

  render() {
    const { user, orgAdminLoading } = this.props;
    const { t } = this.props;
    return (
      <Grid.Row>
        <Grid.Column>
          {user.role !== 'guest' && (
            <CustomSegment title={t('auth.help.takso_administrators')}>
              <Segment loading={orgAdminLoading} className="content-segment">
                {this.renderAdminList()}
              </Segment>
            </CustomSegment>
          )}

          <CustomSegment
            title={t('auth.help.frequently_asked_questions')}
            extraMargin
            className="frequently-asked-questions"
          >
            <Segment className="content-segment">
              <Grid.Row>
                <Grid.Column>
                  <Accordion fluid exclusive={true} panels={this.panels()} />
                </Grid.Column>
              </Grid.Row>
            </Segment>
          </CustomSegment>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.authentication.user,
    adminList: state.organization.orgAdmins,
    orgAdminLoading: state.organization.orgAdminLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getOrganisationAdmins }, dispatch);
};

Help = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Help));
export default Help;
